import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { ThemeConstantService } from "./services/theme-constant.service";
import { SearchPipe } from "./pipes/search.pipe";
import { ItemCountComponent } from "./components/item-count/item-count.component";
import { HasAnyAuthorityDirective } from "./directives";
import { IconFilterPipe } from "./pipes/iconFilter.pipe";
import { SearchFilterComponent } from "src/app/shared/components/search-filter/search-filter.component";
import { ErrorTextComponent } from "src/app/shared/components/error-text/error-text.component";
import { ConfirmPopUpComponent } from "src/app/shared/components/confirm-popup/confirm-popup.component";
import { TransformMoneyPipe } from "./pipes/transformMoney.pipe";
import { DropdownSearchComponent } from "./components/dropdown-search/dropdown-search.component";
import { UserAuthorityDirective } from "./directives/user-authority.directive";
import { DocumentsComponent } from "./components/documents/documents";
import { AutoCompleteComponent } from "./components/auto-complete/auto-complete.component";
import { InputValueRangeComponent } from "./components/input-value-range/input-value-range.component";
import { PagingComponent } from "./components/paging/paging.component";
import { FilterStartEndDateComponent } from "./components/filter-start-end-date/filter-start-end-date";
import { CreateProductComponent } from "../modules/product/components/create-product/create-product.component";
import { InputDateComponent } from "./components/input-date/input-date";
import { InputNumberComponent } from "./components/input-number/input-number";
import { InputNoteComponent } from "./components/input-note/input-note.component";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { NzBackTopModule } from "ng-zorro-antd/back-top";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzPaginationModule } from "ng-zorro-antd/pagination";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzNotificationModule } from "ng-zorro-antd/notification";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzPageHeaderModule } from "ng-zorro-antd/page-header";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { AddBenefitComponent } from "../modules/product/components/add-benefit/add-benefit.component";

@NgModule({
  exports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NzBadgeModule,
    IconFilterPipe,
    NzBackTopModule,
    NzTagModule,
    NzTableModule,
    NzInputModule,
    NzPaginationModule,
    NzPageHeaderModule,
    NzFormModule,
    NzDividerModule,
    NzIconModule,
    NzToolTipModule,
    SearchPipe,
    NzNotificationModule,
    NzBackTopModule,
    HasAnyAuthorityDirective,
    SearchFilterComponent,
    ErrorTextComponent,
    DropdownSearchComponent,
    AutoCompleteComponent,
    TransformMoneyPipe,
    UserAuthorityDirective,
    DocumentsComponent,
    InputValueRangeComponent,
    PagingComponent,
    FilterStartEndDateComponent,
    CreateProductComponent,
    InputDateComponent,
    InputNumberComponent,
    InputNoteComponent,
    AddBenefitComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzTagModule,
    NzNotificationModule,
    NzDropDownModule,
    NzBackTopModule,
    NzBadgeModule,
    NzModalModule,
    NzTableModule,
    NzInputModule,
    NzFormModule,
    NzIconModule,
    NzToolTipModule,
    NzDividerModule,
    NzPageHeaderModule,
  ],
  declarations: [
    IconFilterPipe,
    SearchPipe,
    ItemCountComponent,
    ErrorTextComponent,
    DropdownSearchComponent,
    AutoCompleteComponent,
    HasAnyAuthorityDirective,
    SearchFilterComponent,
    ConfirmPopUpComponent,
    TransformMoneyPipe,
    UserAuthorityDirective,
    DocumentsComponent,
    InputValueRangeComponent,
    FilterStartEndDateComponent,
    PagingComponent,
    CreateProductComponent,
    InputDateComponent,
    InputNumberComponent,
    InputNoteComponent,
    AddBenefitComponent,
  ],
  providers: [ThemeConstantService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
